import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const LOAD_SCHEDULE = createAction('[schecule] Cargar Solicitudes', props<{ professionalId: string }>());
export const LOAD_SCHEDULING = createAction('[schedule] Cargar Solicitudes Agendamiento ', props<{ professionalId: string }>());
export const LOAD_SCHEDULE_OK = createAction('[schecule] OK Cargar Solicitudes', props<{ offers: any[] }>());
export const LOAD_SCHEDULE_ERR = createAction('[schecule] ERR Cargar Solicitudes', props<{ payload: HttpErrorResponse }>());
